<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_bc24"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="getLimit('role_search_button')" @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="getLimit('role_add_button')" @click="funcAdd('add')">
          新增
        </el-button>
        <el-button v-if="getLimit('role_export_button')" @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      show-footer
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      :loading="loading"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="(item, index) in branchList"
              :key="'branchCode' + index"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="roleName"
          title="角色名称"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.roleName"
            placeholder="请输入角色名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="角色类型"
          min-width="150"
          :formatter="formatterType"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.type" clearable placeholder="请选择">
            <el-option
              v-for="(item, index) in typeList"
              :key="'typeListCode' + index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="description"
          title="备注"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.description"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="250">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('role_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcAdd('details', scope.row.code)">
              <em class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('role_edit_button') && scope.row.type != 1"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcAdd('edit', scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('role_delete_button') && scope.row.type != 1"
            class="item"
            effect="dark"
            content="删除"
            placement="top"
          >
            <vxe-button type="text" @click="funcDelete(scope.row.code)">
              <em class="el-icon-delete" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('role_permission_button')"
            class="item"
            effect="dark"
            content="授权"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcPermission(scope.row.code, scope.row.branchCode)"
            >
              <em class="el-icon-setting" />
            </vxe-button>
          </el-tooltip>
          <el-tooltip
            v-if="getLimit('role_AuthorizeNotice_button')"
            class="item"
            effect="dark"
            content="授权通知"
            placement="top"
          >
            <vxe-button
              type="text"
              @click="funcAuthorizeNotice(scope.row.code)"
            >
              <em class="el-icon-bell" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :page-sizes="Pagingconf"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelAddFlag"
      :title="modeladdTitle"
      width="500"
      height="300"
      resize
    >
      <compAdd
        ref="addRef"
        @fatherAddMethod="fatherAdd"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <vxe-modal
      v-model="modelPermissionFlag"
      title="角色授权"
      width="450"
      height="750"
      resize
    >
      <compPermission ref="permissionRef" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <vxe-modal
      v-model="modelNoticeFlag"
      title="授权通知"
      width="400"
      height="800"
      resize
    >
      <compNotice ref="noticeRef" @fatherCancelMethod="fatherCancel" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compAdd from "./components/roleAdd.vue";
import compPermission from "./components/rolePermission.vue";
import compNotice from "./components/roleNotice.vue";
import request from "@/utils/request";
export default {
  name: "RoleList",
  components: {
    compAdd,
    compPermission,
    compNotice
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/role/exportRole", //导出接口
        name: "角色管理"
      },
      message: "",
      loading: false,
      tableData: [],
      modelAddFlag: false,
      modeladdTitle: "新增",
      modelNoticeFlag: false,
      modelPermissionFlag: false,
      copy: false,
      listQuery: {
        branchCode: "",
        role: "",
        roleName: "",
        type: "",
        description: "",
        getStaff: 1,
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      // 类型
      typeList: [
        { label: "管理员添加", value: 0 },
        { label: "内置角色", value: 1 }
      ]
    };
  },
  computed: {
    branchList() {
      return this.$store.state.components.branchList;
    }
  },
  watch: {
    "$store.state.components.branchList": function() {
      this.$refs.xTable.updateData();
    }
  },
  created() {
    this.typeList = [{ label: "管理员添加", value: 0 }];
    const partyType = this.$store.getters.party.partyType;
    if (partyType === "SUPER_ADMIN")
      this.typeList.push({ label: "内置角色", value: 1 });
    this.findList();
  },
  methods: {
    findList() {
      return new Promise(resolve => {
        this.loading = true;
        request({
          url: "/ntocc-basic-api/role",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(branch => branch.code === cellValue);
      return item ? item.groupName : "";
    },
    // 添加方法
    funcAdd(type, code) {
      this.modelAddFlag = true;
      let title = type == "edit" ? "编辑" : "详情";
      this.modeladdTitle = type == "add" ? "新增" : title;
      this.$refs.addRef.getInfo(type, code);
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/role`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      switch (modelFlag) {
        case "add":
          this.modelAddFlag = false;
          break;
        case "permission":
          this.modelPermissionFlag = false;
          break;
        case "notice":
          this.modelNoticeFlag = false;
          break;
        default:
      }
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 翻译类型
    formatterType({ cellValue }) {
      const item = this.typeList.find(type => type.value === cellValue);
      return item ? item.label : "";
    },
    // 授权
    funcPermission(code, branchCode) {
      this.$refs.permissionRef.getInfo(code, branchCode);
      this.modelPermissionFlag = true;
    },
    // 授权通知
    funcAuthorizeNotice(code) {
      this.$refs.noticeRef.getInfo(code);
      this.modelNoticeFlag = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
